<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
    <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>

<!--begin::Main-->
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
    <!--begin::Content wrapper-->
    <div class="d-flex flex-column flex-column-fluid">

        <!--begin::Toolbar-->
        <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
            <!--begin::Toolbar container-->
            <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                <!--begin::Page title-->
                <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <!--begin::Title-->
                    <div class="d-flex align-items-center">
                        <h1 class="page-heading mt-0 mb-0"> <svg width="41" height="44" viewBox="0 0 41 44" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_615_2549)">
                                    <path
                                        d="M15.1976 30.5794C16.2337 29.2326 17.8276 28.4404 19.5013 28.4404H25.7973C26.7537 28.4404 27.6303 28.0443 28.2679 27.4105L36.0782 19.3298C36.3173 19.0922 36.3173 18.6168 36.0782 18.3792C35.8391 18.1415 35.4406 18.0623 35.2016 18.2207L27.8694 22.5779C27.6303 23.7663 26.5943 24.7169 25.3191 24.7169H17.987C17.5885 24.7169 17.19 24.4 17.19 23.9247C17.19 23.5286 17.5885 23.1325 17.987 23.1325H25.3191C25.877 23.1325 26.3552 22.6572 26.3552 22.1026C26.3552 21.5481 25.877 21.0727 25.3191 21.0727H14.1616C12.5676 21.0727 11.0534 21.7857 10.097 22.9741L7.30762 26.3014L14.4803 31.6885L15.1976 30.5794Z"
                                        fill="#265D91" />
                                    <path
                                        d="M14.8784 33.9066L14.1611 33.352L6.27108 27.4104L4.75684 29.3117L13.3641 35.8079L14.8784 33.9066Z"
                                        fill="#265D91" />
                                    <path
                                        d="M9.93705 17.2701H30.8177C31.4552 17.2701 31.9334 16.7948 31.9334 16.161V10.1401C28.108 11.4869 24.2028 12.1999 20.3773 12.1999C16.5519 12.1999 12.6467 11.4869 8.82129 10.1401V16.161C8.82129 16.7948 9.29947 17.2701 9.93705 17.2701Z"
                                        fill="#265D91" />
                                    <path
                                        d="M31.9334 8.15949V4.59451C31.9334 3.96073 31.4552 3.4854 30.8177 3.4854H25.7967V1.10874C25.7967 0.633412 25.3983 0.158081 24.8404 0.158081H15.9143C15.4361 0.158081 14.958 0.55419 14.958 1.10874V3.4854H9.93705C9.29947 3.4854 8.82129 3.96073 8.82129 4.59451V8.15949C16.4722 11.0115 24.2825 11.0115 31.9334 8.15949ZM16.791 1.98018H23.884V3.40618H16.791V1.98018ZM19.1819 6.97116C19.1819 6.25817 19.7398 5.62439 20.3773 5.62439C21.0149 5.62439 21.5728 6.17894 21.5728 6.97116C21.5728 7.68416 21.0149 8.31793 20.3773 8.31793C19.7398 8.31793 19.1819 7.68416 19.1819 6.97116Z"
                                        fill="#265D91" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_615_2549" x="0.756836" y="0.158081" width="39.501"
                                        height="43.6498" filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_615_2549" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_615_2549"
                                            result="shape" />
                                    </filter>
                                </defs>
                            </svg>
                            Modification {{isInterType? 'intercontrat' : 'consultant'}}
                        </h1>
                        <!--begin::Menu-->
                    </div>
                    <!--end::Title-->
                    <!--begin::Breadcrumb-->
                    <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">
                            <a routerLink="/accueil" class="text-muted ">Accueil</a>
                          </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted"> <a class="text-muted " routerLink="/consultants">Nos consultants</a></li>
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">Modification {{isInterType? 'intercontrat' : 'consultant'}}</li>
                        <!--end::Item-->
                    </ul>
                    <!--end::Breadcrumb-->
                </div>
                <!--end::Page title-->
                <!--begin::Actions-->

                <!--end::Actions-->
            </div>
            <!--end::Toolbar container-->
        </div>
        <!--end::Toolbar-->

        <!--begin::Content-->

        <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container container-fluid">
                <!--begin::Card-->
                <div class=" card content">

                    <!--begin::Card header-->
                    <div class="container-content">
                        <div class="d-flex flex-wrap header-grid align-items-center">
                            <div class="section-title">
                                <h1 class="section-heading">Modifier un {{isInterType? 'intercontrat' : 'consultant'}}</h1>
                            </div>
                        </div>

                        <form [formGroup]="formconsultant">
                            <!--begin::Modal body-->
                            <div class="modal-body mx-5 my-7">
                              <div class="row">
                                <div class="col-lg-6 tools">
                                  <label for="email" class="required">Email personnel</label>
                                  <input type="text" formControlName="email" id="email " class="form-control mb-5 cursor-not-allowed"
                                    placeholder="email personnel" [readonly]="true">
                                  <app-feild-error [control]="formconsultant.get('email')" [controlName]="'email'"></app-feild-error>
                                </div>
                                <div class="col-lg-6 tools">
                                  <label for="email">Email professionnel</label>
                                  <input type="text" formControlName="emailProESN" id="email " class="form-control mb-5"
                                    placeholder="email professionnel">
                                  <app-feild-error [control]="formconsultant.get('emailProESN')"
                                    [controlName]="'emailProESN'"></app-feild-error>
                                </div>
                                <div class="col-lg-6 tools">
                                  <label for="name" class="required">Prénom</label>
                                  <input type="text" formControlName="first_name" id="name" class="form-control mb-5 cursor-not-allowed" placeholder="Prénom"
                                    [readonly]="true">
                                  <app-feild-error [control]="formconsultant.get('first_name')"
                                    [controlName]="'first_name'"></app-feild-error>
                                </div>
                                <div class="col-lg-6 tools">
                                  <label for="name" class="required">Nom</label>
                                  <input type="text" formControlName="last_name" id="name" class="form-control mb-5 cursor-not-allowed" placeholder="Nom"
                                    [readonly]="true">
                                  <app-feild-error [control]="formconsultant.get('last_name')"
                                    [controlName]="'last_name'"></app-feild-error>
                                </div>
                                <div class="col-lg-6 tools">
                                  <label for="web">
                                  LinkedIn</label>
                                  <input type="text" formControlName="linkedin_link" id="name" class="form-control mb-5"
                                  placeholder="https://www.linkedin.com/in/" (input)="setValidatorRequirements()">
                                  <app-feild-error [control]="formconsultant.get('linkedin_link')"></app-feild-error>
                                </div>
                                <div class="col-lg-6 tools">
                                  <div class="flex_input">
                                    <div class="w-100">
                                      <div class="labels">
                                        <span>
                                          <label for="cv" class="me-2">Importer CV {{fileName.length > 0 ? ': '.concat(fileName) : ''}}</label>
                                          <i class="fa fa-info-circle me-2" aria-hidden="true"  [style]="{color: '#265d91'}" [ngbTooltip]="'Le cv doit être (.pdf,.doc,.docx).'"></i>
                                        </span>
                                        <a class="cv"></a>
                                        <!-- <button *ngIf="fileName !== '' && !iscv" class="more-label" (click)="resetCV()">
                                          <img src="assets/media/icons/icon-delete.png" alt="" width="30px" class="cursor-pointer">
                                        </button> -->
                                      </div>
                                    </div>
                                    <!-- <input id="fileInput" #inputFile type="file" 
                                      name="cv" id="cv"
                                      (change)="uploadFile($event);setValidatorRequirements()" 
                                      class="form-control mb-3"> -->
                                      <input id="fileInput" #inputFile type="file" 
                                      name="cv" id="cv"
                                      (click)="$event.preventDefault()" disabled
                                      class="form-control mb-3">
                                      
                                    <span style="color:red" *ngIf="fileError"><small>{{ fileError }}</small></span>
                                    <span style="color:red" *ngIf="fileExtention"><small>{{ fileExtention }}</small></span>
                                  </div>
                                </div>
                                <div class="col-lg-6 tools">
                                  <label for="name">Poste</label>
                                  <input type="text" formControlName="desired_workstation" id="desired_workstation"
                                    class="form-control mb-5 cursor-not-allowed" placeholder="Nom" [readonly]="true">
                                  <app-feild-error [control]="formconsultant.get('desired_workstation')"
                                    [controlName]="'desired_workstation'"></app-feild-error>
                                </div>
                                <div class="col-lg-6 tools">
                                  <label for="fin">Client</label>
                                  <ng-select [items]="listclient" formControlName="client_id" bindLabel="name" bindValue="uuid"
                                    [notFoundText]="'Aucun élément trouvé'" [placeholder]="'Client'"></ng-select>
                                  <app-feild-error [control]="formconsultant.get('client_id')"
                                    [controlName]="'client_id'"></app-feild-error>
                                </div>
                                <div class="col-lg-6 tools">
                                  <label for="début">Date de début de mission</label>
                                   <div class="position-relative d-flex align-items-center calenderDate">
                                      <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"
                                      placeholder="JJ/MM/AA" inputId="yearpicker"formControlName="mission_start_date" id="debut" class="form-control mb-5"
                                      [disabled]="!formconsultant.get('client_id')?.value"></p-calendar>
                                      <app-feild-error [control]="formconsultant.get('mission_start_date')"
                                    [controlName]="'mission_start_date'"></app-feild-error>
                                  </div>
                                </div>
                                <div class="col-lg-6 tools">
                                  <label for="fin">Date de fin de mission</label>
                                  <!-- Ajoutez l'attribut [disabled] en fonction de la valeur de client_id -->
                                    <div class="position-relative d-flex align-items-center calenderDate">
                                      <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"
                                      placeholder="JJ/MM/AA" inputId="yearpicker" formControlName="mission_end_date" id="fin" class="form-control mb-5"
                                      [disabled]="!formconsultant.get('client_id')?.value"></p-calendar>
                                      <app-feild-error [control]="formconsultant.get('mission_end_date')"
                                      [controlName]="'mission_end_date'"></app-feild-error>
                                      <div *ngIf="formconsultant.hasError('dateRangeInvalid')" style="color: red;">
                                        La date de début mission ne peut pas être supérieure à la date de fin mission.
                                      </div>
                                  </div>
                                </div>
                                <div class="col-lg-6 tools">
                                  <label for="fin">Salaire</label>
                                  <div class="combined-input mb-5">
                                    <input type="number" min="0" oninput="validity.valid||(value='0');" formControlName="salary"
                                      id="Salaire" class="form-control" placeholder="Salaire &euro;">
                                    <div class="euro">
                                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                          fill="#4B4B4B" />
                                      </svg>
                                    </div>
                                  </div>
                                  <app-feild-error [control]="formconsultant.get('salary')" [controlName]="'salary'"></app-feild-error>
                                </div>
                                <div class="col-lg-6 tools">
                                  <label for="fin">TJM achat</label>
                                  <div class="combined-input mb-5">
                                    <input type="number" min="0" oninput="validity.valid||(value='0');" formControlName="tjm_achat"
                                      id="tjm_achat" class="form-control " placeholder="TJM achat &euro;">
                                    <div class="euro">
                                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                          fill="#4B4B4B" />
                                      </svg>
                    
                                    </div>
                                  </div>
                                  <app-feild-error [control]="formconsultant.get('tjm_achat')"
                                    [controlName]="'tjm_achat'"></app-feild-error>
                                </div>
                                <div class="col-lg-6 tools">
                                  <label for="fin">TJM vente</label>
                                  <div class="combined-input mb-5">
                                    <input type="number" min="0" oninput="validity.valid||(value='0');" formControlName="tjm_vente"
                                      id="tjm_vente" class="form-control " placeholder="TJM vente &euro;">
                                    <div class="euro">
                                      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                          fill="#4B4B4B" />
                                      </svg>
                    
                                    </div>
                                  </div>
                                  <app-feild-error [control]="formconsultant.get('tjm_vente')"
                                    [controlName]="'tjm_vente'"></app-feild-error>
                                </div>
                                <div class="col-lg-6 tools">
                                  <label for="fin">Date de signature du contrat</label>
                                    <div class="position-relative d-flex align-items-center calenderDate mb-5">
                                      <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"
                                      placeholder="JJ/MM/AA" inputId="yearpicker" formControlName="date_signature_contrat" id="debut" class="form-control"></p-calendar>
                                      <app-feild-error [control]="formconsultant.get('date_signature_contrat')"
                                      [controlName]="'date_signature_contrat'"></app-feild-error>
                                    </div>
                                </div>
                                <div class="col-lg-6 tools mb-5">
                                  <label for="fin">Manager</label>
                                  <ng-select [items]="listmanager" formControlName="manager_id" bindLabel="full_name"
                                    [notFoundText]="'Aucun élément trouvé'" bindValue="uuid" [placeholder]="'Manager'">
                                  </ng-select>
                                  <app-feild-error [control]="formconsultant.get('manager_id')"
                                    [controlName]="'manager_id'"></app-feild-error>
                                </div>
                              </div>
                            </div>
                          </form>

                      
                    </div>
                <div class="row card-body">
                    <div class="actions">
                         <a class="action-btn cancel" routerLink="/consultants">Annuler</a>
                        <button  class="action-btn add"  (click)="updateConsultant()"
                                [disabled]="(!isDateRangeValid() || formconsultant.invalid || !formconsultant.dirty) && !isUpdatedCV">
                            Confirmer
                        </button>
                    </div>
                </div>

                </div>
            </div>
        </div>
    </div>
</div>